import React, { useEffect, useState } from 'react';
import { uniq } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@material-ui/core';
import { TextField, Typography } from '../../../../../../ui-kit';
import { localizeEnum } from '../../../../../../utils';
import { UnitType } from '../../../../../../generated/graphql';
import { StockCard } from '../../types';

const getSubtypeUnits = (unitType?: UnitType | null) => {
    switch (unitType) {
        case UnitType.Pcs:
            return [UnitType.Pcs];

        case UnitType.Kg:
        case UnitType.G:
            return [UnitType.Kg, UnitType.G];

        case UnitType.Liter:
        case UnitType.Ml:
            return [UnitType.Liter, UnitType.Ml];

        default:
            return [];
    }
};

interface UnitSelectProps {
    stockCard?: StockCard | null;
    value?: UnitType | null;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const UnitSelect = ({ stockCard, value, onChange }: UnitSelectProps) => {
    const { t } = useTranslation();
    const [units, setUnits] = useState<UnitType[]>([]);

    useEffect(() => {
        if (!stockCard) {
            setUnits([]);
            return;
        }

        const { storageUnit, conversionUnit } = stockCard;
        setUnits(uniq([
            ...getSubtypeUnits(storageUnit),
            ...getSubtypeUnits(conversionUnit),
        ]));
    }, [stockCard]);

    if (units.length === 0) {
        return null;
    }

    if (units.length === 1) {
        return (
            <Typography variant='body2' color='textPrimary'>
                {localizeEnum(t)(units[0], { UnitType })}
            </Typography>
        );
    }

    return (
        <TextField
            select
            onChange={onChange}
            value={value || ''}
            margin='none'
        >
            {units.map(unitType => (
                <MenuItem key={unitType} value={unitType}>{localizeEnum(t)(unitType, { UnitType })}</MenuItem>
            ))}
        </TextField>
    );
};

export default UnitSelect;
